import { render } from "./DatesBoth.component.vue?vue&type=template&id=37468b87"
import script from "./DatesBoth.component.vue?vue&type=script&lang=js"
export * from "./DatesBoth.component.vue?vue&type=script&lang=js"

import "./DatesBoth.component.vue?vue&type=style&index=0&id=37468b87&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
